// extracted by mini-css-extract-plugin
export default {"contentEditorSidebarBlockSettings--visible":"UQ4PcXBw9aMXs6MqWkCh"};